import { combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, createMigrate } from 'redux-persist';

import pricesReducer from '../slices/prices-slice';
import transactionsReducer from '../slices/transactions-slice';
import clientProfitReducer from '../slices/client-profit-slice';
import balanceReducer from '../slices/contract-balance-slice';

// ----------------------------------------------------------------------

const migrations = {
  // version 1: ensure no financial data persists from any older config
  1: (state) => ({
    ...state,
    contractBalance: undefined,
    prices: undefined,
    settings: undefined,
    transactions: undefined,
  }),
};

// Nothing financial is persisted. All slices are live-updated via socket
// on every connect. Do NOT add contractBalance, transactions, prices, or
// clientProfit (mapped as 'settings') to this whitelist.
export const clientPersistConfig = {
  key: 'client',
  storage,
  keyPrefix: 'redux-',
  version: 1,
  migrate: createMigrate(migrations, { debug: false }),
  whitelist: [],
};

const clientAppReducer = combineReducers({
  contractBalance: balanceReducer,
  prices: pricesReducer,
  settings: clientProfitReducer,
  transactions: transactionsReducer,
});

const clientRootReducer = (state, action) => {
  if (action.type === 'RESET_STORE') {
    return {
      ...state,
      transactions: undefined,
    };
  }

  return clientAppReducer(state, action);
};

export const persistedClientReducer = persistReducer(clientPersistConfig, clientRootReducer);

export default clientRootReducer;
